import {Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import strings from '../../../translations';
import styleSheet from './styles';

const AnalyticsLessonListHeaderComponent = () => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  return (
    <View style={[styles.defaultCellStyle, styles.headerListStyle]}>
      <View style={styles.flexStart}>
        <Text style={styles.headerTextStyle}>
          {strings.createClassScreen.subject}
        </Text>
      </View>

      <View style={styles.flexStart}>
        <Text style={styles.headerTextStyle}>
          {strings.createClassScreen.group}
        </Text>
      </View>

      <View style={styles.flexStart}>
        <Text style={styles.headerTextStyle}>
          {strings.analyticsScreen.status}
        </Text>
      </View>

      <View style={styles.width200} />
    </View>
  );
};

export default AnalyticsLessonListHeaderComponent;
